<template>
  <el-container>
    <el-main>
      <h3 class="heading">
        Edit creative
        <span v-if="campaign"> in campaign {{ campaign.name }} </span>
      </h3>
      <el-card>
        <CreativeForm
          v-if="campaign && creative"
          v-model="creative"
          :loading="loading"
          action-text="Update"
          @submit="onSubmit"
        />
      </el-card>
      <LoadingBlock :loading="fetchingCampaign && !creative" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import CreativeForm from '@/apps/traforama/views/creatives/components/CreativeForm.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import useFetchCampaign from '@/hooks/useFetchCampaign'
import { CreativeValidationErrorsKey } from '@/api/types'
import { ICreativeAttributes } from '@/api/creatives'
import useValidation from '@/hooks/useValidation'
import useRouter from '@/hooks/useRouter'
import { ElMessage } from 'element-plus'
import { useCreativesStore } from '@/apps/traforama/store/creatives'
import { safeSubmitProcessing } from '@/utils/helpers'

export default defineComponent({
  name: 'EditCreative',
  components: {
    CreativeForm,
    LoadingBlock
  },
  props: {
    campaignId: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const creativesStore = useCreativesStore()
    const { campaign, fetchingCampaign, fetchCampaign, provideCampaign } =
      useFetchCampaign()
    fetchCampaign(props.campaignId)
    provideCampaign()

    const { provideValidation, setValidationErrors } = useValidation(
      CreativeValidationErrorsKey
    )
    const errors = provideValidation()

    const loading = ref(true)

    const creative = ref(undefined)

    const { router } = useRouter()

    creativesStore.FetchItem(props.id).then(() => {
      loading.value = false
      // @ts-ignore: Type 'ICreativeAttributes' is not assignable to type 'undefined.
      creative.value = creativesStore.itemById(props.id)
      if (creative.value !== undefined) {
        // @ts-ignore: Object is possibly 'undefined'
        creative.value.auto_cpa_setting_attributes =
          creativesStore.autoCpaSettingById(props.id)
      }
    })

    const onSuccess = async () => {
      await router.push('/campaigns')
      ElMessage.success({ message: 'Creative has been created' })
    }

    const onSubmit = async ({
      creative,
      withReview
    }: {
      creative: ICreativeAttributes
      withReview: boolean
    }) => {
      errors.value = {}
      await safeSubmitProcessing(
        loading,
        () => creativesStore.SaveItem(creative),
        () => onSuccess(),
        (err) => setValidationErrors(err, errors)
      )
    }

    return { campaign, fetchingCampaign, creative, loading, onSubmit }
  }
})
</script>
